/** @format */

import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useGlobal, setGlobal } from 'reactn';
import { useTranslation } from 'react-i18next';

import { Row, Col, Form } from 'antd';

import { GetUserData } from '../../../../components/Commons/Hooks/Functions/GetUserData';
import { PixelFacebook } from '../../../../components/Commons/Hooks/Functions/PixelFacebook';
import { amountProductsCart } from '../../../../components/Commons/Hooks/Functions/AmountProductsCart';
import { GetOrder } from '../../../../components/Commons/Hooks/Functions/GetOrder';
import MetaDescription from '../../../../components/Commons/MetaDescription';

import PersonalData from './components/PersonalData';
import DeliverySelect from './components/DeliverySelect';
import PickupDaySelect from './components/PickupDaySelect';
import ButtonRetirement from './components/ButtonRetirement';

import CheckoutTimeLine from '../../../../components/CheckoutTimeLine';
import CheckoutGlobalTitle from '../../../../components/CheckoutGlobalTitle';
import Countdown from '../../../../components/Countdown';

import PaymentDetail from '../../components/PaymentDetail';
import CardOnDemand from '../../components/CardOnDemand';
import LoadingService from '../../components/LoadingService';

import { ReserveCheckSave } from './service';

import { ENV_ISO_CURRENCY } from '../../../../components/Commons/Hooks/Variables/Enviroment';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { pharmacyFeatures } from '../../../../v2-config/constants/pharmacy-features.constant';
import ScrollToTop from '../../../../v2-components/ScrollToTop';
import AgreementCheckbox from './components/AgreementCheckbox';

import './style.scss';
import DescriptionPrices from '../../components/PaymentDetail/components/DescriptionPrices';
import CheckoutTypeDelivery from './CheckoutTypeDelivery';
import { GlobalConsumer } from '../../../../components/Commons/Context/Global';
import { handleLocals } from '../../../carts/functions/BagCalculation/components/BagLocals';
import { handleCountPharmacies } from '../../../carts/functions/BagCountPharmacies';
import { Calculation } from './components/CheckoutCalculation/services';
import CheckoutAddress, { persistAddressWithoutNumber, readAddressWithoutNumberFromSession } from './components/CheckoutAddress';
import { extractFirstStreetNumber } from './utils/extractFirstStreetNumber';
import { CustomNotification } from '../../../../v2-components/Antd/Notification';
import { NOTIFICATION } from '../../../../v2-components/Antd/Notification/constant';

export default function Retirement() {
	const { t } = useTranslation('global');
	const history = useHistory();
	const {
		isSelectedDeliveryType,
		setSelectedDeliveryType,
		setCheckoutDeliveryAvailable,
		setCheckoutPickupAvailable,
		isBag,
		isLocation,
		// setLocation,
		isLoginUser,
		isCheckoutDeliveryAvailable,
		isCheckoutPickupAvailable,
		isSelectionRetirementType,
		setSelectionRetirementError,
	} = GlobalConsumer();
	const [isBagVoucherPharmacies] = useGlobal('bagVoucherPharmacies');

	const [form] = Form.useForm();
	const [isUserEmail] = useState(localStorage.getItem('userEmail'));
	const [isProductsCooled, setProductsCooled] = useState(false);
	const [isUserAddress] = useState(JSON.parse(localStorage.getItem('locationStore')));
	const [isRetirementData, setRetirementData] = useGlobal('retirementData');
	const [isOnDemand] = useState(JSON.parse(localStorage.getItem('onDemandData')));
	const [personalData, setPersonalData] = useState({});
	const [isMobile, setMobile] = useState(false);
	const [isVisible, setVisible] = useState(false);
	const [billing, setBilling] = useState({
		modal: false,
		check: false,
	});
	const [typeValue, setTypeValue] = useState(null); // 'domicilio' | 'farmacia'
	const [responseDelivery, setResponseDelivery] = useState(null);
	const [responsePickup, setResponsePickup] = useState(null);
	// eslint-disable-next-line
	const [isAddressValidated, setAddressValidated] = useGlobal('isAddressValidated');
	const [isRecalculatingDelivery] = useGlobal('isRecalculatingDelivery');
	const [isDeliveryLoading, setDeliveryLoading] = useState(true);
	const [isPickupLoading, setPickupLoading] = useState(true);
	// const [isFromPayment, setFromPayment] = useGlobal('isFromPayment');
	// const [isFromBag, setFromBag] = useGlobal('isFromBag');
	const { setTransactionSelected } = GlobalConsumer();

	// const currentTypeValue = isSelectedDeliveryType ? 'domicilio' : 'farmacia';

	const [date] = useState(new Date());
	const prevSelectedDeliveryType = useRef(isSelectedDeliveryType);

	// const originalLocation = {
	// 	address: 'Región Metropolitana,  Vitacura,  Chile',
	// 	commune: ' Vitacura',
	// 	default: true,
	// 	lat: -33.3906218,
	// 	lng: -70.5631221,
	// 	region: ' Chile',
	// 	street: 'Región Metropolitana',
	// };

	const mergeProductsIntoFirstLocalGroup = (data) => {
		if (!data?.locals_group || data.locals_group.length <= 1) return data;

		let groups = [...data.locals_group];

		if (groups[0]?.type_calculation === 'quotation' && groups.length > 1) {
			const temp = groups[0];
			groups[0] = groups[1];
			groups[1] = temp;
		}
		const [first, ...rest] = groups;

		const extraProducts = rest.flatMap((g) => g?.products || []);

		const mergedProducts = [...(first.products || []), ...extraProducts];

		return {
			...data,
			locals_group: [
				{
					...first,
					products: mergedProducts, // Aquí ya van absolutamente todos agrupados
				},
				...rest, // Mantenemos la estructura de los demás grupos
			],
		};
	};

	useEffect(() => {
		let info = JSON.parse(localStorage.getItem('retirementData'));
		const userCheckout = JSON.parse(localStorage.getItem('form_retirement'));
		const phone = userCheckout?.phone?.replace(/^56/, '');
		let productsIDs = [];
		info.products.forEach((item) => {
			if (item.id_pharol) productsIDs.push(`${item.id_pharol}`);
			if (item.cooled === '1') setProductsCooled(true);
		});
		console.log('userCheckout', userCheckout);
		console.log('isOnDemand', isOnDemand);
		const communeAct = isUserAddress?.commune ? isUserAddress.commune.replace(/\d+/g, '').trim() : '';

		const formFields = `${isLocation?.formFields ?? ''}`;
		const parts = formFields
			.split(',')
			.map((s) => s.trim())
			.filter(Boolean);

		const third = parts[2] || '';
		const extractedNumber = extractFirstStreetNumber(third) || 'S/N';

		const savedAddressWithoutNumber = readAddressWithoutNumberFromSession();

		form.setFieldsValue({
			...userCheckout,
			email: isUserEmail ? isUserEmail : userCheckout?.email,
			street: isUserAddress?.streetName || isUserAddress?.street,
			commune: communeAct,
			phone: phone,
			type_house: isLocation?.houseType,
			reference: isLocation?.reference_ad || '-',
			street_number: extractedNumber, // Ya no usamos "|| 0" para evitar pasar un entero
			number_dpto_house: isLocation?.floorDeptTower || '-',
			...(savedAddressWithoutNumber !== undefined ? { addressWithoutNumber: savedAddressWithoutNumber } : {}),
		});
		setRetirementData(info);

		if (isUserEmail && !isOnDemand) {
			GetUserData(isUserEmail).then((response) => {
				console.log('response', response);
				form.setFieldsValue(response);
				const restored = readAddressWithoutNumberFromSession();
				if (restored !== undefined) {
					form.setFieldsValue({ addressWithoutNumber: restored });
				}
			});
		}
		if (isOnDemand) {
			form.setFieldsValue({
				first_name: isOnDemand.first_name,
				last_name: isOnDemand.last_name,
				email: isOnDemand.email,
				phone: isOnDemand.phone,
				rut: isOnDemand.rut,
			});
		}
		console.log('form', form.getFieldValue('phone'));
		PixelFacebook('InitiateCheckout', {
			content_ids: productsIDs,
			content_type: 'product_group',
			currency: ENV_ISO_CURRENCY,
			num_items: amountProductsCart(),
			value: parseInt(info.total).toFixed(2),
		});
		if (window.innerWidth < 992) {
			setMobile(true);
		}
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isUserEmail, setRetirementData, isUserAddress, form, isOnDemand]);

	console.log('isSelectedDeliveryType', isSelectedDeliveryType);
	console.log('isSelectionRetirementType', isSelectionRetirementType);

	useEffect(() => {
		async function ProcesCart() {
			const originalInfo = JSON.parse(localStorage.getItem('retirementData'));

			const mergedInfo = mergeProductsIntoFirstLocalGroup(originalInfo);

			console.log('mergedInfo', mergedInfo);

			if (!mergedInfo?.locals_group?.length) return;

			const item = mergedInfo.locals_group[0];

			let deliveryMap = {};
			let pickupMap = {};

			let userData;
			if (isLoginUser?.email) {
				userData = await GetUserData(isLoginUser.email);
			}

			deliveryMap[item.name] = null;
			pickupMap[item.name] = null;

			item.products.forEach((p) => delete p.type_retirement);

			const deliveryResp = await Calculation(
				item.products,
				isLocation,
				isLoginUser.email,
				isLoginUser.token,
				isBagVoucherPharmacies,
				handleLocals(isBag),
				'domicilio',
				userData,
				true,
				handleCountPharmacies(),
			);

			if (deliveryResp) {
				setDeliveryLoading(false);
				deliveryMap[item.name] = deliveryResp.locals_group?.[0]?.locals?.length > 0 ? deliveryResp.locals_group[0] : false;
				setResponseDelivery(deliveryResp);
			} else {
				// setLocation(originalLocation);
				deliveryMap[item.name] = false;
			}

			const pickupResp = await Calculation(
				item.products,
				isLocation,
				isLoginUser.email,
				isLoginUser.token,
				isBagVoucherPharmacies,
				handleLocals(isBag),
				'farmacia',
				userData,
				true,
				handleCountPharmacies(),
			);

			if (pickupResp) {
				setPickupLoading(false);
				pickupMap[item.name] = pickupResp.locals_group?.[0]?.locals?.length > 0 ? pickupResp.locals_group[0] : false;
				setResponsePickup(pickupResp);
			} else {
				pickupMap[item.name] = false;
			}

			setCheckoutDeliveryAvailable(deliveryMap);
			setCheckoutPickupAvailable(pickupMap);

			if (isSelectedDeliveryType && deliveryResp) {
				setRetirementData(deliveryResp);
			} else if (!isSelectedDeliveryType && pickupResp) {
				setRetirementData(pickupResp);
			}
		}

		ProcesCart(); // eslint-disable-next-line
	}, [isLocation]);

	// const getTypeDocument = () => {
	// 	let cart = JSON.parse(localStorage.getItem('cart'));
	// 	if (!Array.isArray(cart)) {
	// 		cart = [];
	// 	}

	// 	if (cart) {
	// 		let requireRecipe = cart.some((product) => {
	// 			return product.prescription_type !== 'NP';
	// 		});

	// 		let checkNamePharmacy = cart.some((product) => {
	// 			return product.pharmacy !== cart[0].pharmacy;
	// 		});

	// 		if (requireRecipe || checkNamePharmacy) {
	// 			return true;
	// 		} else {
	// 			return false;
	// 		}
	// 	}
	// };
	const handleChangeType = (next) => {
		if (!isRetirementData?.locals_group?.length) return;

		const groupName = isRetirementData.locals_group[0].name;

		const calculatedGroup = next === 'domicilio' ? isCheckoutDeliveryAvailable?.[groupName] : isCheckoutPickupAvailable?.[groupName];

		if (!calculatedGroup || calculatedGroup === null) {
			return;
		}

		const newLocalsGroup = [...isRetirementData.locals_group];
		newLocalsGroup[0] = {
			...calculatedGroup,
			type_retirement: next,
		};

		if (next === 'domicilio') {
			setRetirementData(responseDelivery);
			localStorage.setItem('retirementData', JSON.stringify(responseDelivery));
		} else {
			setRetirementData(responsePickup);
			localStorage.setItem('retirementData', JSON.stringify(responsePickup));
		}
		// setTypeValue(next);
		setSelectedDeliveryType(next === 'domicilio'); // esto controla el render del DeliverySelect

		const scheduleGroup =
			isRetirementData.locals_group.length === 1
				? isRetirementData.locals_group[0]
				: isRetirementData.locals_group[0].type_calculation === 'quotation'
					? isRetirementData.locals_group[1]
					: isRetirementData.locals_group[0];
		form.setFieldsValue({
			[`date_schedule_${scheduleGroup.name}`]: undefined,
			[`day_schedule_${scheduleGroup.name}`]: undefined,
		});
		setGlobal({ selectedDate: null });
	};

	const scrollToFirstError = () => {
		if (!isMobile) return;
		const selector = '.ant-form-item-explain.ant-form-item-explain-error, .ph-bag-address-text-error, .ph-bag-recipes-info-upload-subtitle, .ph-check-recipe-cart p, .ph-checkout-type-delivery-card-footer-advertise-validation';
		const timeout = 1500;
		const interval = 100;
		const start = Date.now();
		const tryFind = () => {
			const errors = document.querySelectorAll(selector);
			if (errors && errors.length > 0) {
				const list = Array.from(errors).map((el) => ({ el, y: el.getBoundingClientRect().top + window.pageYOffset }));
				list.sort((a, b) => a.y - b.y);
				const first = list[0];
				try {
					if (first && first.el && first.el.scrollIntoView) {
						first.el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
					} else {
						const top = first.el.getBoundingClientRect().top + window.pageYOffset;
						const target = Math.max(top - window.innerHeight / 2 + (first.el.getBoundingClientRect().height || 0) / 2, 0);
						window.scrollTo({ top: target, behavior: 'smooth' });
					}
				} catch (e) {
					const top = first.el.getBoundingClientRect().top + window.pageYOffset;
					const target = Math.max(top - window.innerHeight / 2 + (first.el.getBoundingClientRect().height || 0) / 2, 0);
					window.scrollTo({ top: target, behavior: 'smooth' });
				}
				const input = first.el.closest('.ant-form-item')?.querySelector('input, textarea, select, .ant-select');
				if (input) {
					try {
						input.focus();
					} catch (e) {}
				}
				return;
			}
			if (Date.now() - start < timeout) setTimeout(tryFind, interval);
		};
		tryFind();
	};

	console.log('isRetirementData', isRetirementData);
	const handleSubmitRetirement = async (item) => {
		if (isSelectedDeliveryType) {
			try {
				await form.validateFields(['region', 'commune', 'direction', 'houseType', 'floorDeptTower']);
			} catch (e) {
				scrollToFirstError();
				return; // aquí AntD ya muestra los mensajes por rules
			}
		}

		if (isSelectionRetirementType === 'pharmacy' && pharmacyFeatures.pickupDaySelect && isRetirementData?.locals_group?.[0]) {
			const pickupGroup =
				isRetirementData.locals_group.length === 1
					? isRetirementData.locals_group[0]
					: isRetirementData.locals_group[0].type_calculation === 'quotation'
						? isRetirementData.locals_group[1]
						: isRetirementData.locals_group[0];
			try {
				await form.validateFields([`date_schedule_${pickupGroup.name}`]);
			} catch (e) {
				scrollToFirstError();
				return;
			}
		}

		if (isSelectedDeliveryType && !isAddressValidated) {
			CustomNotification({
				type: NOTIFICATION.TYPE.ERROR,
				message: 'Falta validar la dirección',
				description: 'Debes validar la dirección antes de continuar',
			});
			return;
		}

		if (isSelectedDeliveryType && item?.addressWithoutNumber) {
			item.street_number = 'S/N';
			form.setFieldsValue({ street_number: 'S/N' });
		}

		if (isSelectedDeliveryType && item?.street_number !== undefined && item?.street_number !== null) {
			item.street_number = String(item.street_number);
		}

		if (isSelectedDeliveryType) {
			const floorDeptTower = item.floorDeptTower || form.getFieldValue('floorDeptTower');
			if (floorDeptTower) {
				item.number_department = floorDeptTower;
				item.number_dpto_house = floorDeptTower;
			}
		}

		let info = JSON.parse(localStorage.getItem('retirementData'));
		let retirement = { ...isRetirementData };

		// if (isRetirementData.locals_group.some((group) => group.type_retirement === 'farmacia')) {
		// 	let allSelected = [];
		// 	isRetirementData.locals_group.forEach((group) => {
		// 		if (group.type_retirement === 'farmacia') {
		// 			allSelected.push(!!group.local_selected);
		// 		}
		// 	});
		// 	console.log('allSelected', allSelected);
		// 	if (!allSelected.every((item) => item === true)) {
		// 		Notify({
		// 			title: `¡Sin local!`,
		// 			colorTitle: 'ph-main-notification-error-title',
		// 			description: `Por favor termine de seleccionar los locales de retiro.`,
		// 			time: 3,
		// 			image: 'error',
		// 			placement: 'topRight',
		// 		});
		// 		return;
		// 	}
		// }
		// -----> Lo que pasa con esto es que esta lógica funciona como tal si narma tuviese varias farmacias, el backend no me trae el local seleccionado como tal porque asume 1 sola farmacia en estos momentos. Más que todo veo esta lógica aplicada para
		console.log('isSelectionRetirementType', isSelectionRetirementType);
		if (isSelectionRetirementType === null) {
			setSelectionRetirementError(true);
			scrollToFirstError();
			return;
		}
		retirement['pharmacy'] = [];
		retirement.locals_group.forEach((group) => {
			let newFields = {
				description: `${group.name_editable}, ${group.locals[0].direction}, ${group.locals[0].distance_text}`,
				schedule_selected:
					group.type_calculation !== 'quotation'
						? !pharmacyFeatures.deliveryTimeSelect
							? `${item[`date_schedule_${group.name}`]}`
							: `${item[`date_schedule_${group.name}`]}; ${item[`day_schedule_${group.name}`]}`
						: null,
				detail_pharmacy: `${group.name}, ${group.locals[0].distance_text}, ${group.locals[0].duration}`,
			};

			if (group.schedule_delivery && group.type_calculation !== 'quotation') {
				group.schedule_delivery.forEach((element) => {
					if (item[`date_schedule_${group.name}`] === element.date) {
						element.timers.forEach((data) => {
							if (`${item[`day_schedule_${group.name}`]}` === `${data.start_time} - ${data.end_time}`) {
								newFields = { ...newFields, schedule_object: data };
							}
						});
					}
				});
			}

			'local_selected' in group
				? retirement['pharmacy'].push({ ...group.local_selected, ...newFields })
				: retirement['pharmacy'].push({ ...group.locals[0], ...newFields });
		});

		setGlobal({ retirementButtonLoading: true });
		setVisible(true);
		console.log('item', item);
		item.phone = `56${item.phone}`; // FIX ME: HARDCODED COUNTRY CODE OF CHILE
		console.log('addres aqui', isUserAddress);
		const userAddress = JSON.parse(localStorage.getItem('locationStore'));
		// console.log('isUserAddressas', isUserAddressas);

		await GetOrder({
			...retirement,
			...item,
			isUserAddress: userAddress,
			type_retirement: retirement.pharmacy.some((element) => element.type_retirement === 'domicilio') ? 'domicilio' : 'farmacia',
			info_billing: personalData?.info_billing,
		}).then((response) => {
			if (response) {
				setGlobal({ retirementButtonLoading: false });
				localStorage.setItem('paymentData', JSON.stringify(response));
				console.log('response, valida orden: ', response);

				if (Enviroment.ROOT_RESERVE) {
					ReserveCheckSave('mercagopago-ar', response, info.total)
						.then((response) => {
							history.push('/transactions/success-reserve');
						})
						.catch((e) => {
							history.push('/transactions/error-reserve');
						});
				} else {
					return history.push('/checkout/payment');
				}
			}
		});
	};
	// useEffect(() => {
	// 	if (isSelectedDeliveryType) {
	// 		form.setFieldsValue({
	// 			region: undefined,
	// 			commune: undefined,
	// 			direction: '',
	// 			houseType: undefined,
	// 			floorDeptTower: '',
	// 			alias: '',
	// 			reference: '',
	// 			addressValidated: false,
	// 		});
	// 	}
	// 	if (
	// 		isSelectedDeliveryType &&
	// 		isAddressValidated &&
	// 		(form.getFieldValue('region') === undefined || form.getFieldValue('commune') === undefined || form.getFieldValue('direction') === '')
	// 	) {
	// 		setAddressValidated(false);
	// 	}
	// }, [isSelectedDeliveryType]);

	useEffect(() => {
		const prev = prevSelectedDeliveryType.current;

		// SOLO cuando el usuario cambia de pickup -> delivery
		if (!prev && isSelectedDeliveryType) {
			persistAddressWithoutNumber(false);
			form.setFieldsValue({
				region: undefined,
				commune: undefined,
				direction: '',
				houseType: undefined,
				floorDeptTower: '',
				alias: '',
				reference: '',
				addressValidated: false,
				addressWithoutNumber: false,
			});
		}

		// if (
		// 	isSelectedDeliveryType &&
		// 	isAddressValidated &&
		// 	(form.getFieldValue('region') === undefined || form.getFieldValue('commune') === undefined || form.getFieldValue('direction') === '')
		// ) {
		// 	setAddressValidated(false);
		// }

		prevSelectedDeliveryType.current = isSelectedDeliveryType;
	}, [isSelectedDeliveryType, form]);

	useEffect(() => {
		setTypeValue(isSelectionRetirementType === 'delivery' ? 'domicilio' : isSelectionRetirementType === 'pharmacy' ? 'farmacia' : null);
	}, [isSelectionRetirementType]);

	useEffect(() => {
		setTransactionSelected(false);
		// eslint-disable-next-line
	}, []);

	return (
		<>
			<ScrollToTop />
			<MetaDescription title={t('main.metaTitle')} name={'description'} content={t('main.metaContent')} />
			{isRetirementData && (
				<>
					<div className="ph-withdrawal-global-container">
						<div className="ph-withdrawal-main-container">
							<CheckoutTimeLine step={1} />
							<div className="ph-withdrawal-titlebox-countdown-container">
								<CheckoutGlobalTitle
									// image={'tracking'}
									title={'Datos de compra'}
									// subtitle1="Completa tus datos para finalizar"
									checkout={true}
								/>
								<Countdown />
							</div>
							<Form onFinish={handleSubmitRetirement} name="retirement_form" form={form}>
								<Row>
									<Col xs={24} sm={24} md={24} lg={15} xl={15}>
										<PersonalData
											form={form}
											personalData={personalData}
											isRetirementData={isRetirementData}
											billing={billing}
											setBilling={setBilling}
											setPersonalData={setPersonalData}
										/>
										<CheckoutTypeDelivery
											item={isRetirementData.locals_group[0]}
											value={typeValue}
											onChangeType={handleChangeType}
											form={form}
											isDeliveryLoading={isDeliveryLoading}
											isPickupLoading={isPickupLoading}
										/>
										{isSelectionRetirementType === 'delivery' && (
											<>
												<CheckoutAddress form={form} />
												<DeliverySelect
													group={
														isRetirementData.locals_group.length === 1
															? isRetirementData.locals_group[0]
															: isRetirementData.locals_group[0].type_calculation === 'quotation'
																? isRetirementData.locals_group[1]
																: isRetirementData.locals_group[0]
													}
													isMobile={isMobile}
													checkout={isRetirementData}
													isProductsCooled={isProductsCooled}
													isUserAddress={isUserAddress}
													isUserEmail={isUserEmail}
													form={form}
												/>
											</>
										)}
										{isSelectionRetirementType === 'pharmacy' && pharmacyFeatures.pickupDaySelect && (
											<PickupDaySelect
												group={
													isRetirementData.locals_group.length === 1
														? isRetirementData.locals_group[0]
														: isRetirementData.locals_group[0].type_calculation === 'quotation'
															? isRetirementData.locals_group[1]
															: isRetirementData.locals_group[0]
												}
												form={form}
											/>
										)}
									</Col>

									<Col xs={24} sm={24} md={24} lg={9} xl={9} className="ph-withdrawal-checkout-box-global-container">
										<CardOnDemand />

										<div className="ph-withdrawal-checkout-box-main-container">
											<PaymentDetail address={isUserAddress} item={isRetirementData} fromWithdrawal={true} />
										</div>

										<div className="ph-withdrawal-card-gap" />

										<div className="ph-withdrawal-checkout-box-main-container">
											{!isRecalculatingDelivery && (
												<DescriptionPrices
													type="retirement"
													title={`Total a pagar:`}
													price={
														!isAddressValidated && isSelectedDeliveryType ? isRetirementData?.total - isRetirementData?.total_delivery : isRetirementData?.total
													}
												/>
											)}
											<div className="ph-checkout-main-box-delivery-container"></div>
											<ButtonRetirement type="retirement" item={isRetirementData} />
											<AgreementCheckbox form={form} date={date} billing={billing} setBilling={setBilling} setPersonalData={setPersonalData} />
										</div>
									</Col>
								</Row>
							</Form>
						</div>
					</div>
					<LoadingService visible={isVisible} />
				</>
			)}
		</>
	);
}
